import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseQuickMeetingVariables {
  title: string;
}

export interface UseQuickMeetingData {
  link: string;
  room_address: string;
  title: string;
}

export function useQuickMeeting() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseQuickMeetingData,
    AxiosError<UseQuickMeetingData>,
    UseQuickMeetingVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .post<UseQuickMeetingData>(`/posht/yashar/meetings/instant/`, data)
        .then((res) => res.data);
    },
    {
      onError: (error, variables, context) => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
    },
  );
}
